export const SELECTED_PLANNING_GROUPS = 'SELECTED_PLANNING_GROUPS';
export const LOCATION_PIN_MODE = 'LOCATION_PIN_MODE';
